import { createAmerAPI } from './amerAPI';

/**
 * Creates a new waitlist entry using the new endpoint
 * @param {string} baseUrl - Base URL for the API
 * @param {string} token - Authentication token (not used directly, but kept for API compatibility)
 * @param {Object} waitlistData - Waitlist entry data
 * @returns {Promise<Object>} - Promise resolving to the response
 */
export const createWaitlistEntry = async (baseUrl, token, waitlistData) => {
  try {
    const amerAPI = createAmerAPI(baseUrl);

    const response = await amerAPI.post('/waitlist', waitlistData);

    return response.data;
  } catch (error) {
    throw error;
  }
};
